<template>
  <aside :style="holderBg">
    <div
      v-if="heroImageSrc && !$route.meta.isAdmin && !$route.meta.hideBanner"
      v-scroll="handleScroll"
      class="c-hero-slider"
      :style="cssStyle"
      :class="{ 'is-home': isHome }"
    >
      <div class="c-hero-slider__content">
        <h3 class="c-hero-slider__title">
          {{ displayBanner.title }}
          <span class="read-more" v-if="buttonText">
            <base-button outline @click="handleClick">{{
              buttonText
            }}</base-button>
          </span>
        </h3>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

import filesApi from '@/api/files'

export default {
  name: 'hero-slider',

  data() {
    return {
      isFixed: false,
      heroImageSrc: '',
      holderBg: { background: '#768692' },
      displayBanner: {}
    }
  },

  methods: {
    handleClick() {
      if (this.displayBanner.link_url) {
        return window.open(this.displayBanner.link_url)
      }

      // if the resource is a document or policy
      if (this.displayBanner.resource.current_version) {
        // eforms are different too
        if (this.displayBanner.resource.self.includes('eformmanagement')) {
          return this.$router.push({
            path: `/forms/${this.displayBanner.resource.eform_url}`
          })
        } else {
          const docId = this.displayBanner.resource.id
          const docType = this.displayBanner.resource.self.includes('policy')
            ? 'policies'
            : 'forms'
          return this.$router.push({ path: `/documents/${docType}/${docId}` })
        }
      }

      // if we are a file
      if (this.displayBanner.resource.file_hash) {
        this.$store
          .dispatch('files/read', this.displayBanner.resource.id)
          .then(resp => {
            return this.$store.dispatch('files/download', resp)
          })

          return;
      }

      this.$router.push({ path: `/${this.displayBanner.resource.self}` })
    },

    getImageData(data) {
      const vm = this
      const reader = new FileReader()
      reader.readAsDataURL(data)
      reader.onloadend = function() {
        const base64data = reader.result
        vm.heroImageSrc = base64data
      }
    },
    handleScroll(event, el) {
      // TODO:
      // const vm = this;
      // console.log("handleScroll: ", window.scrollY);
      // if (window.scrollY > 186) {
      //   vm.isFixed = true;
      //   vm.$store.commit("setFixedBanner", true);
      // } else {
      //   vm.isFixed = false;
      //   vm.$store.commit("setFixedBanner", false);
      // }
    }
  },

  computed: {
    ...mapState(['fixedBanner']),

    buttonText () {
      return this.displayBanner.button_text
    },

    isHome() {
      return this.$route.name == 'Dashboard'
    },

    cssStyle() {
      if (!this.$store.state.fixedBanner) {
        return {
          backgroundImage: `url(${this.heroImageSrc})`
        }
      }
      return {
        // position: "fixed",
        // top: "-87px",
        // left: "0",
        // right: "0",
        backgroundImage: `url(${this.heroImageSrc})`
      }
    }
  },

  created() {
    this.$store
      .dispatch('getFixedBanner')
      .then(resp => {
        if (resp) {
          console.log('TCL: created -> resp', resp)

          // do we have an image?
          if (resp.file) {
            filesApi.readLink(resp.file.link).then(response => {
              this.getImageData(response.data)
            })
          } else {
            this.heroImageSrc = '/assets/event-thumb.svg'
          }

          this.displayBanner = resp
        }
      })
      .catch(err => console.log(err))
  }
}
</script>

<style lang="scss">
.c-hero-slider {
  // /* height: 300px; */
  height: 150px;
  /* margin-top: 96px; */
  /* margin-left: 55px; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  z-index: 20;
  display: flex;

  cursor: pointer;


  .read-more button {
    display: block;
    background: $colour-nhs-blue;
    border-radius: 0;
    width: 100%;
    border: none;
    position: absolute;
    bottom: 0;
    left: 0;

    @media (min-width: 768px) {
      display: block;
      border-radius: 2em;
      width: auto;
      border: none;
      margin: 10px auto 0;
      position: relative;
      background: transparent;
      border: 1px solid white;

      &:hover {
        background: white;
      }
    }
  }
}

.c-hero-slider::after {
  position: absolute;
  content: '';
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0.94) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 21;
}

.c-hero-slider__content {
  display: inline-flex;
  align-self: center;
  width: 100%;
  z-index: 22;
  text-align: center;

  @media (min-width: 768px) {
    align-self: flex-end;
  }
}

.c-hero-slider__title {
  color: $colour-nhs-white;
  font-size: 24px;
  width: 100%;
  text-align: center;
  padding-bottom: 50px;

  @media (min-width: 768px) {
    padding-bottom: 0;
  }
}

@media screen and (min-width: 1024px) {
  .c-hero-slider {
    /* margin-top: 96px; */
    /* margin-left: 55px; */
  }
}
</style>
